enum API_TRANSACTION_TYPE {
  SUBSCRIPTION = 'subscriptions',
  DONATION = 'donations'
}

export default API_TRANSACTION_TYPE
